// Unpublished Work © 2020-2024 Deere & Company.

export default {
    '3': 3,
    '2': 2,
    '1': 1
};
